import { Card, Col, Row, Button } from "antd";
import { useNavigate } from "react-router-dom";
import ReactGA from "react-ga4";
import React from "react";
import productsNotFound from "../../assets/images/icons/productEmpty.png";
import NoImage from "../../assets/images/Image_not_available.png";
import DetailPopup from "./partials/DetailPopup";

interface SkinSolutionComponentInterfacce {
  data: any;
}

const { Meta } = Card;

const data = [
  {
    id: 1,
    name: "Inflammatory Acne",
    image:
      "https://media.canva.com/v2/image-resize/format:PNG/height:200/quality:100/uri:ifs%3A%2F%2FM%2Fba814e7e-a372-4d7c-ba3a-7ef5126adcb8/watermark:F/width:200?csig=AAAAAAAAAAAAAAAAAAAAANFH_6B4u836xn4r_xWu0cUmEWwU6hI40_GWIpyGLozl&exp=1755863851&osig=AAAAAAAAAAAAAAAAAAAAAO3mAMinBJ2rBf0lTVe8c_qeS1nzwwFuOC4RDpC5iuOB&signer=media-rpc&x-canva-quality=thumbnail",
  },
  {
    id: 2,
    name: "Finelines and Wrinkles, Crows Feet",
    image:
      "https://media.canva.com/v2/image-resize/format:PNG/height:200/quality:100/uri:ifs%3A%2F%2FM%2Fba814e7e-a372-4d7c-ba3a-7ef5126adcb8/watermark:F/width:200?csig=AAAAAAAAAAAAAAAAAAAAANFH_6B4u836xn4r_xWu0cUmEWwU6hI40_GWIpyGLozl&exp=1755863851&osig=AAAAAAAAAAAAAAAAAAAAAO3mAMinBJ2rBf0lTVe8c_qeS1nzwwFuOC4RDpC5iuOB&signer=media-rpc&x-canva-quality=thumbnail",
  },
  {
    id: 3,
    name: "Hyperpigmentation, Sun Spots, Age Spots",
    image:
      "https://media.canva.com/v2/image-resize/format:PNG/height:200/quality:100/uri:ifs%3A%2F%2FM%2Fba814e7e-a372-4d7c-ba3a-7ef5126adcb8/watermark:F/width:200?csig=AAAAAAAAAAAAAAAAAAAAANFH_6B4u836xn4r_xWu0cUmEWwU6hI40_GWIpyGLozl&exp=1755863851&osig=AAAAAAAAAAAAAAAAAAAAAO3mAMinBJ2rBf0lTVe8c_qeS1nzwwFuOC4RDpC5iuOB&signer=media-rpc&x-canva-quality=thumbnail",
  },
];

const SkinSolutionComponent: React.FC<SkinSolutionComponentInterfacce> = ({
  data,
}) => {
  const navigate = useNavigate();
  return (
    <section className="store-section skincare-solution missing_skincare">
      <Card>
        <h1 className="title store-card__title">
          Personalized Guide to Your Skin Concern
        </h1>
        {data?.data && data?.data?.length ? (
          <Row gutter={[100, 100]}>
            {data?.data?.map((item: any) => {
              return (
                <Col xl={8} xs={24} md={12} key={item.id}>
                  <Card className="skincare-solution__card">
                    <div className="solution-wrapper">
                      <div className="img-holder">
                        <img alt="example" src={item.image ?? NoImage} />
                        <DetailPopup item={item} noImage={NoImage} />
                      </div>
                      <Meta title={item.name} />
                    </div>
                  </Card>
                </Col>
              );
            
            })}
          </Row>
        ) : (
          <div className="skin-profile__currentSkincare__NotAvailable skin-profile__currentSkincare__NotAvailable--size-lg">
            <div>
              <img className="noItemsImage" src={productsNotFound} alt="" />
            </div>
            <h4 className="text">All of your products looks good!</h4>
          </div>
        )}
        <div className="skincare-solution__info">
          <div className="icon-wrapper">
            <div className="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 24 24" fill="#b5cc4c"><path fill="#b5cc4c" fill-rule="evenodd" d="M2 12a10 10 0 1 1 20 0a10 10 0 0 1-20 0m9.4-5.5a1 1 0 1 0 0 2a1 1 0 1 0 0-2M10 10a1 1 0 1 0 0 2h1v3h-1a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-1v-4c0-.6-.4-1-1-1z" clip-rule="evenodd"/></svg>
            </div>
            <p className="info">Photos are for reference only</p>
          </div>
        </div>
      </Card>
      <div className="footer-cta">
       <Button
          className="btn-primary cta-btn"
          onClick={() => {
            navigate("/store/skincare-tracker");
            ReactGA.event({
              category: "Store",
              action: "Go to Holistic Care button clicked",
              label: "",
              nonInteraction: true,
              transport: "xhr",
            });
          }}
        >
          Go to Skincare Tracker
        </Button>
      </div>

    </section>

  );
};

export default SkinSolutionComponent;
